import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';
import Theme from '../common/NekoTheme';
import { useClasses } from '../hooks';

const Tag = Styled.a`
  background-color: var(--neko-pro-background);
  position: relative;
  border-radius: 10px;
  color: var(--neko-pro-color) !important;
  font-family: ${Theme.fontFamily};
  font-size: 9px;
  line-height: 10px;
  padding: 5px 8px;
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    color: var(--neko-pro-color);
    background-color: var(--neko-pro-background-hover);
  }

  &.inline {
    display: inline;
    margin-left: 5px;
    vertical-align: middle;
  }
`;

/**
 * @param {string} className
 * @param {string|object} icon
 * @param {bool} disabled
 * @param {function} onClick
 */
const StyledProOnly = (props) => {

  const { show = true, className, ...rest } = props;
  const classNames = useClasses('neko-pro-only', className);

  if (!show) {
    return null;
  }

  return (
    <Tag href='https://meowapps.com' target='_blank' className={classNames} {...rest}>
      Pro Only
    </Tag>
  );
};

const ProOnly = (props) => {
  return (<StyledProOnly {...props} />);
}

ProOnly.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string
};

ProOnly.defaultProps = {
  show: true,
  className: undefined
};

export { ProOnly };
